import { AxiosService } from 'src/services/AxiosService';

export class ServiceManager {

  private defaultConfig: AxiosConfig = {
    baseUrl: '',
    visitId: 0,
    facilityCode: ''
  };
  private registeredServices: Map<ServiceConstructor<AxiosService>, ServiceRegistration<AxiosService>> = new Map<ServiceConstructor<AxiosService>, ServiceRegistration<AxiosService>>();

  public registerService<T extends AxiosService>(type: ServiceConstructor<T>): ServiceRegistration<T> {
    if (this.registeredServices.has(type)) {
      throw new Error(`A service has already been registered for type ${type}`);
    }

    const registration: ServiceRegistration<T> = { type };
    this.registeredServices.set(type, registration);
    return registration;
  }

  public service<T extends AxiosService>(type: ServiceConstructor<T>): T {
    let registration = this.registeredServices.get(type);

    if (!registration) {
      registration = this.registerService(type);
    }

    if (registration.instance) {
      return <T>registration.instance;
    }

    registration.instance = this.instantiateService(registration.type);
    return <T>registration.instance;
  }

  public setDefaultConfig(baseUrl: string, visitId: number, facilityCode: string): void {
    this.defaultConfig = {
      baseUrl,
      visitId,
      facilityCode
    };
    this.registeredServices.forEach(registration => this.setServiceConfig(registration));
  }

  private setServiceConfig<T extends AxiosService>(registration: ServiceRegistration<T>): void {

    if (registration.instance) {
      registration.instance.setAxiosConfig(this.defaultConfig);
    }
  }

  private instantiateService<T extends AxiosService>(constructor: ServiceConstructor<T>): T {

    const service = new constructor();
    service.setAxiosConfig(this.defaultConfig);
    return service;
  }

}

interface ServiceRegistration<T extends AxiosService> {
  type: ServiceConstructor<T>;
  instance?: T;
}

export interface ServiceConstructor<T extends AxiosService> { new(): T; }

export interface AxiosConfig {

  baseUrl: string;
  visitId: number;
  facilityCode: string;
}

export const Services = new ServiceManager();